import React from 'react';
import {
    Edit,
    SimpleForm, TextField,
    TextInput,
} from 'react-admin';

const CodigoRechazoEdit = (props) => (
  <Edit  mutationMode="optimistic" {...props}>
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="descripcion" />
    </SimpleForm>
  </Edit>
);

export default CodigoRechazoEdit;
